module.exports = __webpack_public_path__ + "img/BW.abeeebfb.svg";